export default function Store(): JSX.Element {
  return (
    <s-section
      heading="Where are you starting from?"
      subheading="Two quick questions, and we'll skip everything you don't need."
    >
      {/* Step 1: Starting point selector */}
      <s-stack gap="small">
        {/* Options: New to subscriptions or migrating from another app */}
        <s-stack direction="block" gap="small">
          <s-clickable border="base" borderRadius="base" padding="base">
            <s-stack direction="inline" gap="base" alignContent="center">
              <s-badge icon="plus" tone="success" size="large"></s-badge>

              <s-stack direction="block" gap="small-500">
                <s-text fontWeight="semibold">I&apos;m new to subscriptions</s-text>
                <s-text color="subdued">
                  No subscription app on your store yet. We&apos;ll have your first offer on your product page in
                  about ten minutes.
                </s-text>
              </s-stack>
            </s-stack>
          </s-clickable>

          <s-clickable border="base" borderRadius="base" padding="base">
            <s-stack direction="inline" gap="base" alignContent="center">
              <s-badge tone="success" icon="external" size="large"></s-badge>

              <s-stack direction="block" gap="small-500">
                <s-text fontWeight="semibold">I&apos;m moving from another app</s-text>
                <s-text color="subdued">
                  We&apos;ll help you move your existing subscribers, payment methods, and schedules to Smartrr.
                  Your customers won&apos;t notice a thing.
                </s-text>
              </s-stack>
            </s-stack>
          </s-clickable>
        </s-stack>

        {/* Callout to book a call with the team */}
        <s-box background="subdued" borderRadius="base" padding="base">
          <s-stack direction="inline" justifyContent="space-between" alignContent="center">
            <s-stack direction="inline" gap="small-400" alignContent="center">
              <s-text fontWeight="semibold">Rather talk it through?</s-text>
              <s-text color="subdued">
                Book fifteen minutes with us. No commitment, and we&apos;ll set things up together.
              </s-text>
            </s-stack>

            <s-button tone="neutral" variant="auto" icon="calendar">
              Book a call
            </s-button>
          </s-stack>
        </s-box>

        <s-divider />

        {/* Continue button */}
        <s-stack direction="inline" justifyContent="end">
          <s-button variant="primary">Continue</s-button>
        </s-stack>
      </s-stack>
    </s-section>
  );
}
